import React, { useEffect, useState } from 'react'
import Topbar from '../../Components/Topbar'
import LeftbarUser from '../../Components/LeftbarUser'
import BottomNavUser from '../../Components/BottomNavUser'
import { useNavigate, useParams } from 'react-router-dom'
import { getFirestore, doc, getDoc } from 'firebase/firestore'
import { app } from '../../firebase'
import Spinner from 'react-bootstrap/Spinner';
import youtubeIcon from '../../Images/youtube.png'
import instagramIcon from '../../Images/instagram2.png'
import tiktokIcon from '../../Images/tiktok.png'
import twitterIcon from '../../Images/Twitter.svg'
import ProgressBar from 'react-bootstrap/ProgressBar';
import { Button } from 'react-bootstrap'
import swal from 'sweetalert';
import { ToastContainer, toast, Bounce } from 'react-toastify';
import { getStorage, ref as storageRef, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { collection, addDoc, Timestamp } from "firebase/firestore";
import { getAuth, onAuthStateChanged } from "firebase/auth";

function GetStarted() {
    const { id } = useParams()
    const db = getFirestore(app)

    const [loading, setLoading] = useState(true)
    const [data, setData] = useState(null)
    const [selectedSocial, setSelectedSocial] = useState('')
    const [selectedAdType, setSelectedAdType] = useState('')
    const [adTypes, setAdTypes] = useState([])
    const [price, setPrice] = useState('')
    const [step, setStep] = useState(1)
    const [makePaymentBtn, setmakePaymentBtn] = useState(true);
    const [loadingBtn, setloadingBtn] = useState(false);
    const navigate = useNavigate()
    const [showProgress, setshowProgress] = useState();
    const [now, setNow] = useState(0);
    const [loggedInUserId, setloggedInUserId] = useState();
    const [loggedInUserName, setloggedInUserName] = useState();
    const auth = getAuth()


    const imgIcons = {
        instagram: instagramIcon,
        tiktok: tiktokIcon,
        youtube: youtubeIcon,
        twitter: twitterIcon
    }

    const formattedNames = {
        instagram: "Instagram",
        tiktok: "TikTok",
        youtube: "YouTube",
        twitter: "Twitter"
    }

    const [adPurpose, setAdPurpose] = useState('');
    const [businessCategory, setBusinessCategory] = useState('');
    const [brandName, setBrandName] = useState('');
    const [businessDesc, setBusinessDesc] = useState('');
    const [websiteLink, setWebsiteLink] = useState('');
    const [postCaption, setPostCaption] = useState('');
    const [infadsNotAccepted, setinfadsNotAccepted] = useState([]);

    useEffect(() => {
        const fetchInfluencer = async () => {
            const ref = doc(db, "users", id)
            const snap = await getDoc(ref)
            if (snap.exists()) {
                setData(snap.data())
                setinfadsNotAccepted(snap.data().adsNotAccepted);

            }
            setLoading(false)
        }
        fetchInfluencer()
    }, [id])

    const getLowestPrice = platform => {
        const pData = data?.servicePricing?.[platform]
        if (!pData) return null

        const prices = []

        const direct = pData.directBrandContent
        const cgc = pData.creatorGeneratedContent

        if (direct?.post) prices.push(direct.post)
        if (direct?.story) prices.push(direct.story)
        if (cgc?.price) prices.push(cgc.price)

        if (!prices.length) return null

        return Math.min(...prices)
    }

    const handleSocialChange = e => {
        const social = e.target.value

        resetAllPricingStates()
        setSelectedSocial(social)

        if (!social || !data?.servicePricing?.[social]) {
            setAdTypes([])
            return
        }

        const pricing = data.servicePricing[social]
        const types = []

        if (pricing.directBrandContent) {
            if (pricing.directBrandContent.post) {
                types.push({ value: 'post', label: 'Post Upload', price: pricing.directBrandContent.post })
            }
            if (pricing.directBrandContent.story) {
                types.push({ value: 'story', label: 'Story Upload', price: pricing.directBrandContent.story })
            }
        }

        if (pricing.creatorGeneratedContent?.price) {
            types.push({
                value: 'cgc',
                label: 'Creator-Generated Content',
                price: pricing.creatorGeneratedContent.price,
                description: pricing.creatorGeneratedContent.description || '',
                deliveryTime: pricing.creatorGeneratedContent.deliveryTime || ''
            })
        }


        setAdTypes(types)
    }

    const handleAdTypeChange = e => {
        const type = e.target.value

        resetAdTypeStates()
        setSelectedAdType(type)

        const selected = adTypes.find(t => t.value === type)
        setPrice(selected ? selected.price : '')
    }

    const getCGCDescription = () => {
        if (!selectedAdType || selectedAdType !== 'cgc') return ''
        const selected = adTypes.find(t => t.value === 'cgc')
        return selected?.description || 'No description provided'
    }

    const getCGCDeliveryTime = () => {
        if (selectedAdType !== 'cgc') return ''
        const selected = adTypes.find(t => t.value === 'cgc')
        return selected?.deliveryTime || 'Not specified'
    }

    const getSelectedDeliveryTime = () => {
        if (selectedAdType !== 'cgc') return null
        const selected = adTypes.find(t => t.value === 'cgc')
        return selected?.deliveryTime || null
    }



    //who is logged in
    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, async (user) => {
            const uid = user.uid
            const docRef = doc(db, "users", uid)
            const snap = await getDoc(docRef)
            setloggedInUserId(uid)

            if (snap.exists()) {
                const data = snap.data()
                const freshName = data.userName || ""
                setloggedInUserName(freshName)


            }
        })

        return () => unsubscribe()
    }, [])

    const [cgcDetails, setCgcDetails] = useState('')
    const [uploadType, setUploadType] = useState('image')
    const [adDays, setAdDays] = useState(1)
    const [totalCost, setTotalCost] = useState(price)

    useEffect(() => {
        const base = Number(price) || 0

        const shouldUseDays =
            (selectedSocial === 'twitter' && (selectedAdType === 'post' || selectedAdType === 'cgc')) ||
            (selectedSocial === 'instagram' && selectedAdType === 'story')

        if (shouldUseDays) {
            setTotalCost(base * adDays)
        } else {
            setTotalCost(base)
        }
    }, [price, adDays, selectedAdType, selectedSocial])

    const [filePreview, setFilePreview] = useState(null)
    const [videoError, setVideoError] = useState('')

    const handleFileUpload = event => {
        const file = event.target.files[0]
        if (!file) return

        setVideoError('')

        const preview = URL.createObjectURL(file)
        setFilePreview(preview)

        if (file.type.startsWith('video')) {
            const video = document.createElement('video')
            video.src = preview
            video.onloadedmetadata = () => {
                if (video.duration > 61) {
                    setVideoError('Video must be 60 seconds or less.')
                    setFilePreview(null)
                }
            }
        }
    }

    const resetAllPricingStates = () => {
        setSelectedAdType('')
        setAdTypes([])
        setPrice('')
        setTotalCost('')
        setAdDays(1)
        setFilePreview(null)
        setVideoError('')
        setUploadType('image')
        setCgcDetails('')
    }

    const resetAdTypeStates = () => {
        setPrice('')
        setTotalCost('')
        setAdDays(1)
        setFilePreview(null)
        setVideoError('')
        setUploadType('image')
        setCgcDetails('')
    }

    const validateBeforePayment = () => {
        // Check required fields
        if (!adPurpose || !businessCategory || !brandName || !businessDesc || !websiteLink) {
            swal("Error", "Please fill all required fields before proceeding to payment", "error");
            return false;
        }

        // Check file for post/story upload
        if ((selectedAdType === 'post' || selectedAdType === 'story') && !filePreview) {
            swal("Error", "Please upload your file before proceeding to payment", "error");
            return false;
        }

        // Check CGC details
        if (selectedAdType === 'cgc' && !cgcDetails.trim()) {
            swal("Error", "Please provide details for the creator-generated content before proceeding to payment", "error");
            return false;
        }

        // // Check M-PESA number
        // if (!mpesaNumber || !/^07\d{8}$/.test(mpesaNumber)) {
        //     swal("Error", "Please enter a valid M-PESA number", "error");
        //     return false;
        // }

        //check the ads the influencer doesnt accept here 
        if (infadsNotAccepted[businessCategory] === true) {
            swal("Error", `The influencer does not accept ads for ${businessCategory}. Please pick a different category.`, "error");
            return false;
        }

        return true; // All validations passed
    };

    const [showPaymentModal, setShowPaymentModal] = useState(false)
    const [isPaymentProcessing, setIsPaymentProcessing] = useState(false)
    const [paymentTransactionId, setPaymentTransactionId] = useState(null)
    const [paymentCountdown, setPaymentCountdown] = useState(180) // 3 minutes

    const [mpesaNumber, setMpesaNumber] = useState("")
    const baseUrl = 'https://us-central1-zindua-ke.cloudfunctions.net/paymentApi';

    const startCountdown = () => {
        setPaymentCountdown(180)
        const interval = setInterval(() => {
            setPaymentCountdown(prev => {
                if (prev <= 1) {
                    clearInterval(interval)
                    toast.error("Payment timed out. Retrying STK push...")
                    retryPayment(paymentTransactionId)
                    return 0
                }
                return prev - 1
            })
        }, 1000)
    }

    const retryPayment = async (transactionId) => {
        if (!transactionId) return
        await verifyPayment(transactionId)
    }

    const makePayment = async (mpesaNumber) => {
        if (!validateBeforePayment()) return
        setShowPaymentModal(true)
        setIsPaymentProcessing(true)
        setmakePaymentBtn(false)
        setloadingBtn(true)

        const payload = {
            amount: totalCost,
            contact_phone_number: mpesaNumber,
            contact_name: loggedInUserName,
            description: `${selectedAdType} ad payment to influencer`
        }

        try {
            const response = await fetch(`${baseUrl}/make-payment`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            })
            if (!response.ok) throw new Error("Payment request failed")

            const data = await response.json()
            const transactionId = data?.data?.data?.transaction?.id
            setPaymentTransactionId(transactionId)

            toast.success("Payment request sent. Check your phone for STK prompt.")
            startCountdown()
            await verifyPayment(transactionId)

        } catch (err) {
            console.error("Payment initiation error:", err)
            toast.error("Failed to initiate payment. Retrying...")
            setTimeout(() => makePayment(mpesaNumber), 3000)
        }
    }

    const verifyPayment = async (transactionId) => {
        try {
            const response = await fetch(`${baseUrl}/verify-payment/${transactionId}`)
            if (!response.ok) throw new Error("Verification failed")

            const data = await response.json()
            const transaction = data?.data?.data?.transaction?.[0]

            if (!transaction || transaction.status === "pending") {
                setTimeout(() => verifyPayment(transactionId), 5000)
                return
            }

            if (transaction.status === "success") {
                setIsPaymentProcessing(false)
                setShowPaymentModal(false)
                processPayment("Mpesa Choice Bank", "KES", transactionId, "success")
                toast.success("Payment successful!")
            } else {
                setIsPaymentProcessing(false)
                setShowPaymentModal(false)
                swal("Payment failed", `Status: ${transaction.status}`, "error")
            }
        } catch (err) {
            console.error("Verification error:", err)
            setTimeout(() => verifyPayment(transactionId), 5000)
        }
    }

    async function processPayment(payMethod, currency, responseReference, responseTrans) {
        try {
            toast.info("Submitting your ad, please wait...");
            setloadingBtn(true);

            const storage = getStorage(app);
            const db = getFirestore(app);


            const uploadFile = (file) => {
                return new Promise((resolve, reject) => {
                    const storage = getStorage(app);

                    // Create a timestamp
                    const now = new Date();
                    const timestamp = `${now.getFullYear()}${String(now.getMonth() + 1).padStart(2, '0')}${String(now.getDate()).padStart(2, '0')}_${String(now.getHours()).padStart(2, '0')}${String(now.getMinutes()).padStart(2, '0')}${String(now.getSeconds()).padStart(2, '0')}`;

                    // Include timestamp in file name
                    const fileName = `${timestamp}_${file.name}`;
                    const fileRef = storageRef(storage, `ads/${id}/${fileName}`);
                    const uploadTask = uploadBytesResumable(fileRef, file);


                    uploadTask.on('state_changed',
                        (snapshot) => {
                            const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                            setshowProgress(true);
                            setNow(progress);
                        },
                        (error) => {
                            console.error('Upload failed:', error);
                            reject(error);
                        },
                        async () => {
                            const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
                            resolve(downloadURL);
                        }
                    );
                });
            };

            let uploadedFiles = [];
            if (filePreview) {
                const file = document.querySelector('input[type="file"]').files[0];
                try {
                    const url = await uploadFile(file);
                    uploadedFiles.push(url);
                    setshowProgress(false);
                   // console.log('File uploaded:', url);
                } catch (err) {
                    toast.error('File upload failed');
                    setshowProgress(false);
                    return;
                }
            }

            // Prepare ad payload
            const adPayload = {
                influencerId: id,
                social: selectedSocial,
                adType: selectedAdType,
                cgcDetails: cgcDetails || null,
                cgcDeliveryTime: selectedAdType === 'cgc' ? getSelectedDeliveryTime() : null,
                uploadType: uploadType || null,
                adDays: adDays || 1,
                totalCost,
                mpesaNumber: mpesaNumber || null,
                payMethod,
                currency,
                paymentReference: responseReference,
                paymentStatus: responseTrans,
                uploadedFiles,
                adPurpose,
                businessCategory,
                brandName,
                businessDesc,
                websiteLink,
                postCaption,
                loggedInUserId,
                adStatus: "Submitted",
                timestamp: Timestamp.now()
            };

            // Save to Firestore
            const adRef = await addDoc(collection(db, "ads"), adPayload);
            const adID = adRef.id
            sendNotifications(adID)
            await addIncome(payMethod, currency, responseReference, responseTrans, totalCost, mpesaNumber, adID);

        } catch (error) {
            console.error("❌ Error submitting payment/ad:", error.message);
            toast.error(`Submission failed: ${error.message}`);
            setmakePaymentBtn(true);
            setloadingBtn(false);
        }
    }

    async function addIncome(payMethod, currency, responseReference, responseTrans, totalCost, mpesaNumber, adID) {
        const db = getFirestore(app);

        const payoutAmount = 0.2 * totalCost;
        const payoutRem = totalCost - payoutAmount;

        const incomePayload = {
            influencerId: id,
            totalCost,
            mpesaNumber,
            payMethod,
            currency,
            paymentReference: responseReference,
            paymentStatus: responseTrans,
            loggedInUserId,
            adStatus: "Requested",
            incomeType: "adRequest",
            payoutStatus: "Pending",
            payout: payoutRem,
            earnings: payoutAmount,
            timestamp: Timestamp.now(),
            adID
        };

        await addDoc(collection(db, "income"), incomePayload);

        toast.success("Ad submitted successfully!");
        setmakePaymentBtn(true);
        setloadingBtn(false);

        swal({
            title: "Success",
            text: "Ad submitted successfully, the influencer will review it",
            icon: "success"
        }).then(() => {
            navigate("/user/ads");
        });
    }

    async function sendNotifications(adID) {
        const db = getFirestore(app);
        const auth = getAuth();

        const influencerRef = doc(db, "users", id);
        const influencerSnap = await getDoc(influencerRef);
        const influencerData = influencerSnap.data();

        const advertiserRef = doc(db, "users", loggedInUserId);
        const advertiserSnap = await getDoc(advertiserRef);
        const advertiserData = advertiserSnap.data();

        // Get token for authorization
        const token = await auth.currentUser.getIdToken();

        // Email messages
        const influencerEmail = influencerData.email;
        const advertiserEmail = advertiserData.email;

        const emailSubject = "NEW AD SUBMITTED";
        const influencerMessage = `Hi ${influencerData.userName}, a new ad has been submitted for you by ${advertiserData.userName} (Brand: ${brandName}). Check your dashboard for details.`;
        const advertiserMessage = `Hi ${advertiserData.userName}, your ad for ${brandName} has been successfully submitted to ${influencerData.userName}.`;

        // SMS messages
        const influencerPhone = influencerData.mpesaNumber;
        const advertiserPhone = advertiserData.mpesaNumber;
        const smsInfluencer = `Hi ${influencerData.userName}, a new ad has been submitted for you by ${advertiserData.userName}.`;
        const smsAdvertiser = `Hi ${advertiserData.userName}, your ad for ${brandName} has been submitted to ${influencerData.userName}.`;

        try {
            // Send emails
            await fetch("https://us-central1-zindua-ke.cloudfunctions.net/commapi/send-email", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`
                },
                body: JSON.stringify({ email: influencerEmail, subject: emailSubject, message: influencerMessage })
            });

            await fetch("https://us-central1-zindua-ke.cloudfunctions.net/commapi/send-email", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`
                },
                body: JSON.stringify({ email: advertiserEmail, subject: emailSubject, message: advertiserMessage })
            });

            // Send SMS
            await fetch("https://us-central1-zindua-ke.cloudfunctions.net/commapi/send-sms", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`
                },
                body: JSON.stringify({ phoneNumber: influencerPhone, message: smsInfluencer })
            });

            await fetch("https://us-central1-zindua-ke.cloudfunctions.net/commapi/send-sms", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`
                },
                body: JSON.stringify({ phoneNumber: advertiserPhone, message: smsAdvertiser })
            });

            toast.success("Notifications sent to influencer and advertiser!");
        } catch (error) {
            console.error("Error sending notifications:", error);
            toast.error("Failed to send email/SMS notifications");
        }
    }



    return (
        <div className="mainDashboard">
            <div className="desktopOnly">
                <LeftbarUser />
            </div>

            <div className="mainContent">
                <Topbar />

                <section>
                    <div className="alertCont">
                        {loading && <p>Loading...</p>}

                        {!loading && data && (
                            <>
                                <h6>Run an Ad</h6>
                                <p>Submit an ad to <span className='getstartedSpan1'>{data.userName}</span></p>

                                <div className="socials">
                                    {Object.keys(data.socials || {}).map(p => {
                                        const selected = data.socials[p] === true || data.socials[p] === "selected"
                                        if (!selected) return null

                                        const price = getLowestPrice(p)
                                        if (!price) return null

                                        return (
                                            <div key={p} className="socialItem">
                                                <img src={imgIcons[p]} alt={p} className="socialIconImg" />
                                                <div className='getstatedNameCont'>
                                                    <h6>{formattedNames[p]}</h6>
                                                    <span>From KES {Number(price).toLocaleString()}</span>
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>
                            </>
                        )}
                    </div>

                    <div className="adDetails container mt-3" style={{ display: step === 1 ? 'block' : 'none' }}>
                        <div className="row mb-2">

                            <div className="col-md-4">
                                <label className="form-label">Purpose of the Ad</label>
                                <select className="form-select" value={adPurpose} onChange={e => setAdPurpose(e.target.value)}>
                                    <option value="">Select objective</option>
                                    <option value="Drive Sales to my business">Drive Sales to your business</option>
                                    <option value="Introduce a product/Brand">Introduce a product/Brand</option>
                                    <option value="Creating awareness">Creating awareness</option>
                                    <option value="Brand positioning">Brand positioning</option>
                                    <option value="App Installs">App Installs</option>
                                    <option value="Website Visits">Website Visits</option>
                                    <option value="Other">Other</option>
                                </select>
                            </div>

                            <div className="col-md-4">
                                <label className="form-label">Business/Service Category</label>
                                <select className="form-select" value={businessCategory} onChange={e => setBusinessCategory(e.target.value)}>
                                    <option value="">Select Category</option>

                                    <option value="Agriculture">Agriculture</option>
                                    <option value="alcohol">Alcohol and Tobacco</option>
                                    <option value="Automotive">Automotive</option>
                                    <option value="Beauty and Sanitation">Beauty and Sanitation</option>
                                    <option value="Chemical">Chemical</option>
                                    <option value="Construction">Construction</option>
                                    <option value="Education">Education</option>
                                    <option value="Electronics Manufacturing">Electronics Manufacturing</option>
                                    <option value="Electronics Retail">Electronics Retail</option>
                                    <option value="Entertainment">Entertainment</option>
                                    <option value="Events">Events</option>
                                    <option value="Fashion and Beauty">Fashion and Beauty</option>
                                    <option value="Finance">Finance</option>
                                    <option value="Financial Services">Financial Services</option>
                                    <option value="Food and Beverage">Food and Beverage</option>
                                    <option value="Forestry, Wood, Pulp and Paper">Forestry, Wood, Pulp and Paper</option>

                                    <option value="forex">Forex</option>
                                    <option value="trading">Stock Trading</option>
                                    <option value="crypto">Cryptocurrency</option>

                                    <option value="General Retail and Commerce">General Retail and Commerce</option>
                                    <option value="Government Agency">Government Agency</option>
                                    <option value="gambling">Gambling</option>
                                    <option value="Health and Fitness">Health and Fitness</option>
                                    <option value="Health Care and Social Assistance">Health Care and Social Assistance</option>
                                    <option value="Hotels, Tourism, Food and Catering">Hotels, Tourism, Food and Catering</option>
                                    <option value="Information Technology">Information Technology</option>
                                    <option value="Insurance">Insurance</option>
                                    <option value="Manufacturing">Manufacturing</option>
                                    <option value="Mechanical and Electrical Engineering">Mechanical and Electrical Engineering</option>
                                    <option value="Media">Media</option>
                                    <option value="Media and News">Media and News</option>
                                    <option value="Mining">Mining</option>
                                    <option value="Music Industry">Music Industry</option>
                                    <option value="NGO or Community">NGO or Community</option>
                                    <option value="Oil and Gas">Oil and Gas</option>
                                    <option value="Online Trade">Online Trade</option>
                                    <option value="political">Politics / Political / Politician</option>
                                    <option value="Postal and Telecommunications">Postal and Telecommunications</option>
                                    <option value="Professional Services">Professional Services</option>
                                    <option value="Professional, Scientific and Technical Services">
                                        Professional, Scientific and Technical Services
                                    </option>
                                    <option value="Public Service">Public Service</option>
                                    <option value="religious">Religion</option>
                                    <option value="Real Estate">Real Estate</option>
                                    <option value="Retail">Retail</option>
                                    <option value="socialIssues">Social Issues</option>
                                    <option value="Technology">Technology</option>
                                    <option value="Textiles, Clothing, Leather and Footwear">
                                        Textiles, Clothing, Leather and Footwear
                                    </option>
                                    <option value="Transport and Warehousing">Transport and Warehousing</option>
                                    <option value="Travel">Travel</option>
                                    <option value="Utilities">Utilities</option>
                                    <option value="Wholesale Trade">Wholesale Trade</option>
                                    <option value="other">Other</option>
                                </select>
                            </div>

                            <div className="col-md-4">
                                <label className="form-label">Business/Brand name</label>
                                <input type="text" className="form-control" placeholder="Brand Name" value={brandName} onChange={e => setBrandName(e.target.value)} />
                            </div>
                        </div>

                        <div className="row mb-2">
                            <div className="col-md-6">
                                <label className="form-label">What does the brand/business or service do</label>
                                <input type="text" className="form-control" placeholder="What the business or brand does" value={businessDesc} onChange={e => setBusinessDesc(e.target.value)} />
                            </div>

                            <div className="col-md-6">
                                <label className="form-label">Paste your Website or social media link</label>
                                <input type="text" className="form-control" placeholder="Paste your link" value={websiteLink} onChange={e => setWebsiteLink(e.target.value)} />
                            </div>
                        </div>

                        <div className="row mb-3">
                            <div className="col-md-4">
                                <label className="form-label">Where do you want to run the ad</label>
                                <select className="form-select" onChange={handleSocialChange} value={selectedSocial}>
                                    <option value="">Select ad type</option>
                                    {data &&
                                        Object.keys(data.socials || {}).map(p => {
                                            const selected = data.socials[p] === true || data.socials[p] === "selected"
                                            const price = getLowestPrice(p)
                                            if (!selected || !price) return null
                                            return (
                                                <option key={p} value={p}>
                                                    {formattedNames[p]}
                                                </option>
                                            )
                                        })}
                                </select>
                            </div>

                            <div className="col-md-4">
                                <label className="form-label">How do you want to run the ad</label>
                                <select className="form-select" value={selectedAdType} onChange={handleAdTypeChange}>
                                    <option value="">Select option</option>
                                    {adTypes.map(t => (
                                        <option key={t.value} value={t.value}>
                                            {t.label}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className='col-md-4'>
                                <label className="form-label">Price</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    disabled
                                    value={price ? `KES ${Number(price).toLocaleString()}` : ''}
                                />
                            </div>
                        </div>

                        {selectedAdType === 'cgc' && (
                            <div className="row mb-3 alert alert-dark">
                                <p>This is what the creator offers under user generated content:</p>
                                <p>{getCGCDescription()}</p>
                                <p>
                                    <strong>Content delivery time:</strong> {getCGCDeliveryTime()}
                                </p>
                            </div>
                        )}


                        <Button onClick={() => setStep(2)}>Next</Button>
                    </div>

                    <div className='submitContainer' style={{ display: step === 2 ? 'block' : 'none' }}>


                        {selectedAdType === 'cgc' && (
                            <>


                                <div className="mb-3">
                                    <label className="form-label">Give the influencer enough details to create your content</label>
                                    <textarea
                                        className="form-control"
                                        rows={4}
                                        value={cgcDetails}
                                        onChange={e => setCgcDetails(e.target.value)}
                                    />
                                </div>

                                {(selectedSocial === 'twitter' &&
                                    (selectedAdType === 'post' || selectedAdType === 'cgc')) && (
                                        <div className="mb-3">
                                            <label className="form-label">Number of days to run the ad: {adDays}</label>
                                            <input
                                                type="range"
                                                min={1}
                                                max={30}
                                                value={adDays}
                                                onChange={e => setAdDays(Number(e.target.value))}
                                                className="form-range"
                                            />
                                        </div>
                                    )}

                                <div className="alert alert-info">
                                    Your total ad cost will be KES {Number(totalCost).toLocaleString()}
                                </div>
                            </>
                        )}


                        {(selectedAdType === 'post' || selectedAdType === 'story') && (
                            <>

                                <div className="mb-3">
                                    <label className="form-label">What do you want to upload?</label>
                                    <select className="form-select" value={uploadType} onChange={e => setUploadType(e.target.value)}>
                                        <option value="image">Image</option>
                                        <option value="video">Video</option>
                                    </select>
                                </div>

                                <div className="mb-3">
                                    <label className="form-label">Upload your file</label>
                                    <label className="customFileUpload">
                                        <input
                                            type="file"
                                            accept={uploadType === "video" ? "video/*" : "image/*"}
                                            onChange={handleFileUpload}
                                        />
                                        <span>Click to upload file</span>
                                    </label>

                                    {videoError && (
                                        <p className="videoWarning">{videoError}</p>
                                    )}

                                    {filePreview && (
                                        <div className="previewBox">
                                            {uploadType === 'image' && (
                                                <img src={filePreview} alt="preview" className="previewMedia" />
                                            )}

                                            {uploadType === 'video' && (
                                                <video
                                                    src={filePreview}
                                                    className="previewMedia"
                                                    controls
                                                />
                                            )}
                                        </div>


                                    )}

                                </div>

                                <div className='mb-3'>
                                    <label className="form-label">Post caption</label>
                                    <textarea className="form-control" value={postCaption} onChange={e => setPostCaption(e.target.value)} />
                                </div>

                                {(selectedSocial === 'twitter' && (selectedAdType === 'post' || selectedAdType === 'cgc') || (selectedSocial === 'instagram' && selectedAdType === 'story')) && (
                                    <div className="mb-3">
                                        <label className="form-label">Number of days to run the ad: {adDays}</label>
                                        <input
                                            type="range"
                                            min={1}
                                            max={30}
                                            value={adDays}
                                            onChange={e => setAdDays(Number(e.target.value))}
                                            className="form-range"
                                        />
                                    </div>
                                )}

                                <div className="alert alert-info">
                                    Your total ad cost will be KES {Number(totalCost).toLocaleString()}
                                </div>
                            </>
                        )}
                        <Button onClick={() => setStep(1)}>Back</Button>

                        {makePaymentBtn &&
                            <Button
                                variant="success"
                                onClick={() => {
                                    if (validateBeforePayment()) {
                                        setShowPaymentModal(true);
                                    }
                                }}
                            >
                                Submit and Pay
                            </Button>

                        }

                        {loadingBtn && <Button variant="success" disabled className='btnLogin'>
                            <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                            />
                            {" "}Submitting...
                        </Button>
                        }

                        {showProgress &&
                            <ProgressBar now={now} label={`${now}%`} />
                        }
                    </div>


                </section>
            </div >

            <div className="mobileOnly">
                <BottomNavUser />
            </div>

            <div className={`modal fade ${showPaymentModal ? "show" : ""}`}
                style={{ display: showPaymentModal ? "block" : "none", background: "rgba(0,0,0,0.5)" }}>
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content" style={{ borderRadius: "12px" }}>
                        <div className="modal-header">
                            <h5 className="modal-title">Complete Payment</h5>
                            <button type="button" className="btn-close"
                                disabled={isPaymentProcessing}
                                onClick={() => !isPaymentProcessing && setShowPaymentModal(false)}></button>
                        </div>
                        <div className="modal-body text-center">
                            {isPaymentProcessing ? (
                                <>
                                    <Spinner animation="border" size="lg" />
                                    <p>Waiting for M-PESA payment...</p>
                                    <p>Time left: {Math.floor(paymentCountdown / 60)}:{String(paymentCountdown % 60).padStart(2, "0")}</p>
                                </>
                            ) : (
                                <>
                                    <p>Enter your M-PESA number so you can receive a payment prompt.</p>
                                    <input type="number" className="form-control" placeholder="07XX XXX XXX" value={mpesaNumber} onChange={e => setMpesaNumber(e.target.value)} />
                                </>
                            )}
                        </div>
                        <div className="modal-footer">
                            {!isPaymentProcessing && <>
                                <Button variant="secondary" onClick={() => setShowPaymentModal(false)}>Cancel</Button>
                                <Button variant="success" onClick={() => makePayment(mpesaNumber)}>Confirm and Pay</Button>
                            </>}
                        </div>
                    </div>
                </div>
            </div>


            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="dark"
                transition={Bounce}
            />

        </div >
    )
}

export default GetStarted